import { Form } from 'antd';
import React from 'react';
import { IFormDiscountValues } from '../../cashier.interface';
import CashierActionButton from '../../components/CashierActionButton';
import DiscountModalV2 from './DiscountModalV2';
import { ISubmitModalDiscount } from './DiscountModalV2/type';
type Props = {
  value?: number;
  onChange?: (value: number) => void;
  subTotal?: number;
};
const CashierDiscountTicket = ({ onChange = () => undefined, subTotal = 0 }: Props) => {
  const [visible, setVisible] = React.useState(false);
  const onClose = () => setVisible(false);
  const onClick = () => {
    setVisible(true);
  };

  const handleSubmit: ISubmitModalDiscount = (values) => {
    let discount = values.discount;
    if (values.discountType === 'PERCENT') {
      discount = subTotal * (values.discount / 100);
    }

    onChange(discount);
  };

  return (
    <>
      <CashierActionButton
        type='DISCOUNT'
        onClick={onClick}
      />
      <Form.Item shouldUpdate noStyle>
        {({ setFieldValue }) => {
          const saveDiscountSetting = (value: IFormDiscountValues) => setFieldValue('discountSetting', value);
          return (
            <DiscountModalV2
              visible={visible}
              onClose={onClose}
              onSubmit={handleSubmit}
              saveDiscountSetting={saveDiscountSetting}
            />
          );
        }}
      </Form.Item>
    </>
  );
};

export default CashierDiscountTicket;
